// src/contexts/RegistrationProvider.js

import React, { useState } from "react";
import RegistrationContext from "./RegistrationContext";

const RegistrationProvider = ({ children }) => {
  const [screen, setScreen] = useState("login");
  const [maxStep, setMaxStep] = useState("login");
  const [registrationCode, setRegistrationCode] = useState("REG123");
  const [loading, setLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState("");
  const [status, setStatus] = useState("");
  const [reload, setReload] = useState(0);
  const [reloadAdminBadges, setReloadAdminBadges] = useState(0);
  const [data, setData] = useState({});
  const [cartOpen, setCartOpen] = useState(false);
  const [cart, setCart] = useState({});
  const [cartAdded, setCartAdded] = useState(false);
  const [userInfoOpen, setUserInfoOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [phase, setPhase] = useState("");
  const [inCommunication, setInCommunication] = useState(false);
  const [paperOpen, setPaperOpen] = useState(false);
  const [paperSelected, setPaperSelected] = useState([]);
  const [paperSelectedVerified, setPaperSelectedVerified] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminRole, setAdminRole] = useState("");
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [isMainAccess, setIsMainAccess] = useState(false);
  const [optionAccess, setOptionAccess] = useState("");
  const [registrationType, setRegistrationType] = useState("");
  const [clickedNext, setClickedNext] = useState(0);
  const [prices, setPrices] = useState({});
  const [next, setNext] = useState(null);
  const [highlightedCart, setHighlightedCart] = useState(false);
  const [upgradableOptions, setUpgradableOptions] = useState([]);
  const [isSoldout, setIsSoldout] = useState([]);
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false)
  const [workshops, setWorkshops] = useState([]);
  const [tutorials, setTutorials] = useState([]);
  const [papers, setPapers] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [ppiTier, setPpiTier] = useState(null);
  return (
    <RegistrationContext.Provider
      value={{
        screen,
        setScreen,
        authenticated,
        setAuthenticated,
        registrationCode,
        setRegistrationCode,
        loading,
        setLoading,
        error,
        setError,
        status,
        setStatus,
        reload,
        setReload,
        reloadAdminBadges,
        setReloadAdminBadges,
        maxStep,
        setMaxStep,
        data,
        setData,
        cartOpen,
        setCartOpen,
        cart,
        setCart,
        cartAdded,
        setCartAdded,
        userInfoOpen,
        setUserInfoOpen,
        email,
        setEmail,
        phase,
        setPhase,
        inCommunication,
        setInCommunication,
        paperOpen,
        setPaperOpen,
        paperSelected,
        setPaperSelected,
        paperSelectedVerified,
        setPaperSelectedVerified,
        isAdmin,
        setIsAdmin,
        adminRole,
        setAdminRole,
        isImpersonating,
        setIsImpersonating,
        isStudent,
        setIsStudent,
        isMainAccess,
        setIsMainAccess,
        optionAccess,
        setOptionAccess,
        registrationType,
        setRegistrationType,
        clickedNext,
        setClickedNext,
        prices,
        setPrices,
        highlightedCart,
        setHighlightedCart,
        next,
        setNext,
        upgradableOptions,
        setUpgradableOptions,
        isSoldout,
        setIsSoldout,
        disclaimerAccepted,
        setDisclaimerAccepted,
        workshops,
        setWorkshops,
        tutorials,
        setTutorials,
        papers,
        setPapers,
        permissions,
        setPermissions,
        ppiTier,
        setPpiTier,
      }}
    >
      {children}
    </RegistrationContext.Provider>
  );
};

export default RegistrationProvider;
